import type { ChatPageContext } from './pageContext'
import { extractTenantIdFromAccountLinks } from './accountLinks'

/** Tenant cuid from a stored chat pageContext snapshot (if any). */
export function tenantIdFromPageContext(pageContext: unknown): string | undefined {
  if (!pageContext || typeof pageContext !== 'object') return undefined
  const ctx = pageContext as ChatPageContext
  if (ctx.params?.tenantId) return ctx.params.tenantId
  if (ctx.sharedEntity?.type === 'tenant') return ctx.sharedEntity.id
  return undefined
}

/** Best tenant cuid for account linkify: pageContext, then deep links in the body. */
export function resolveAccountLinkTenantId(args: {
  pageContext?: unknown
  markdown?: string
  fallbackTenantId?: string
}): string | undefined {
  return (
    tenantIdFromPageContext(args.pageContext) ??
    (args.markdown ? extractTenantIdFromAccountLinks(args.markdown) : undefined) ??
    args.fallbackTenantId
  )
}
